var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5"},[_vm._m(0),_c('h1',{staticClass:"text-center"},[_vm._v("Mot de passe oublié")]),_c('ForgetPasswordForm')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Retour à la connexion")])])
}]

export { render, staticRenderFns }